/* SUPPLY: facets.js: AJAX filtering and sorting via the Section Rendering API */
(function () {
  'use strict';
  class FacetFiltersForm extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.section;
      this.form = this.querySelector('[data-facets-form]');
      if (!this.form) return;
      this.sortInput = this.form.querySelector('[data-sort-input]');
      this.sortSelect = this.form.querySelector('[data-sort-select]');
      this.debounced = window.theme?.debounce ? window.theme.debounce(() => this.apply(), 350) : () => this.apply();
      this.form.addEventListener('change', (e) => {
        if (e.target === this.sortSelect) { this.sortInput.value = this.sortSelect.value; this.apply(); return; }
        if (e.target.type === 'number') { this.debounced(); return; }
        this.apply();
      });
      this.form.addEventListener('submit', (e) => { e.preventDefault(); this.apply(); });
      this.addEventListener('click', (e) => {
        const link = e.target.closest('[data-facet-remove], [data-facet-clear]');
        if (link) { e.preventDefault(); this.load(link.href); }
      });
      if (!FacetFiltersForm.popstateBound) {
        FacetFiltersForm.popstateBound = true;
        window.addEventListener('popstate', () => { const el = document.querySelector('facet-filters-form'); if (el) el.load(window.location.href, false); });
      }
    }
    apply() {
      const params = new URLSearchParams(new FormData(this.form));
      // drop empty price inputs
      for (const [k, v] of Array.from(params.entries())) { if (v === '') params.delete(k); }
      const url = `${window.location.pathname}?${params.toString()}`;
      this.load(url, true);
    }
    async load(url, push = true) {
      const container = document.getElementById(`ProductGridContainer-${this.sectionId}`);
      container?.classList.add('is-loading');
      try {
        const fetchUrl = new URL(url, window.location.origin);
        fetchUrl.searchParams.set('section_id', this.sectionId);
        const res = await fetch(fetchUrl.toString());
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const ids = [`ProductGridContainer-${this.sectionId}`, `ActiveFacets-${this.sectionId}`, `FacetsDrawerContent-${this.sectionId}`, `ProductCount-${this.sectionId}`, `FacetsToolbar-${this.sectionId}`];
        ids.forEach((id) => {
          const fresh = doc.getElementById(id); const current = document.getElementById(id);
          if (fresh && current) current.innerHTML = fresh.innerHTML;
          else if (fresh && !current && id.startsWith('ActiveFacets')) { const toolbar = document.getElementById(`FacetsToolbar-${this.sectionId}`); toolbar?.insertAdjacentElement('afterend', fresh); }
          else if (!fresh && current && id.startsWith('ActiveFacets')) current.remove();
        });
        // rebind sort select (toolbar was replaced)
        this.sortSelect = this.form.querySelector('[data-sort-select]');
        this.sortInput = this.form.querySelector('[data-sort-input]');
        if (push) window.history.pushState({}, '', url);
        window.theme?.observeReveals && window.theme.observeReveals(document.getElementById(`ProductGridContainer-${this.sectionId}`));
        const top = document.getElementById(`FacetsToolbar-${this.sectionId}`);
        if (top && top.getBoundingClientRect().top < 0) top.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } catch (e) { window.location.href = url; }
      finally { container?.classList.remove('is-loading'); }
    }
  }
  if (!customElements.get('facet-filters-form')) customElements.define('facet-filters-form', FacetFiltersForm);
})();
